import { RootState } from 'internal/rootReducer';

export const selectSessionToken = (state: RootState): string | null => state.appState.token;
